import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import InputGroupContext from '../../../scenes/InputGroupContext';

import { AutocompleteInput } from '../../AutocompleteInput';
import { CheckMark } from '../../CheckMark';
import { Option } from '../../utils';

import styles from '../index.module.css';

export interface OtherAutocompleteEntryProp<T> {
  /** The options used to show in auto complete list */
  autoCompleteOptions: Option<T>[];
  /** The options values that are already selected, they will not be shown on auto complete list again */
  selectedValues: T[];
  /** The action to take on entry clicked */
  onItemClick?: (option: Option<T>) => void;
}

/**
 * Render the `other` option with auto complete input
 */
export function OtherAutocompleteEntry<T>({
  onItemClick,
  autoCompleteOptions,
  selectedValues,
}: OtherAutocompleteEntryProp<T>) {
  const { t } = useTranslation();
  const [otherAutocompleteChecked, setOtherAutocompleteChecked] =
    useState(false);
  const [otherInputValue, setOtherInputValue] = useState('');
  const inputGroup = useContext(InputGroupContext);
  const checkMarkId = `${inputGroup ? `${inputGroup}-` : ''}other-check`;
  return (
    <>
      <CheckMark
        id={checkMarkId}
        label={t('Other')}
        checked={otherAutocompleteChecked}
        onClick={() => setOtherAutocompleteChecked(!otherAutocompleteChecked)}
      />
      {otherAutocompleteChecked && (
        <AutocompleteInput
          ariaLabelledBy={checkMarkId}
          value={otherInputValue}
          placeholder={t('Search...')}
          onSelection={(_, value) => {
            const otherOption = autoCompleteOptions.find(
              (option) => option.display === value,
            );
            if (!otherOption) return;
            onItemClick && onItemClick(otherOption);
            setOtherInputValue('');
            setOtherAutocompleteChecked(false);
          }}
          containerClassName={styles.MultiEnumOtherInputContainer}
          className={styles.MultiEnumOtherInput}
          name="Other"
          onChange={(newValue: string) => setOtherInputValue(newValue)}
          options={autoCompleteOptions
            .filter((option) => !selectedValues.includes(option.value))
            .map((option) => option.display)}
        />
      )}
    </>
  );
}
